import logo from "../../../assets/appIcon.png"
import styles from "./styles.module.scss"

const UnsupportedMobileVersion = () => {
  return (
    <div className={styles.container}>
      <img alt="cruisen logo" src={logo} className={styles.logoImage} />
      <h2 className={styles.title}>Full access on desktop</h2>
      <p className={styles.description}>
        Thank you for signing up as an advisor on Cruisen! For the best experience and full access
        to your dashboard, please use a desktop browser.
      </p>
    </div>
  )
}

export default UnsupportedMobileVersion
